import dayjs from 'dayjs'
// 导相对时间插件
import relativeTime from 'dayjs/plugin/relativeTime'
import isoWeek from 'dayjs/plugin/isoWeek'
// 导国际化插件i18n
import 'dayjs/locale/zh-cn'
import minMax from 'dayjs/plugin/minMax'
import { regex } from './regex'
import cookie from './cookie'
import axios from 'axios'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { customDomainAndLogo } from '@/config/automatic'

dayjs.extend(relativeTime)
dayjs.extend(isoWeek)
dayjs.extend(minMax)
dayjs.extend(quarterOfYear)
dayjs.extend(customParseFormat)
/**
 * 数据存储方式
 */
export const storage = {
  setItem (key, value) {
    key && value && sessionStorage.setItem(key, value)
  },
  getItem: (key) => {
    return (key && sessionStorage.getItem(key)) || ''
  },
  removeItem: (key) => {
    key && sessionStorage.removeItem(key)
  },
  clear: () => {
    sessionStorage.clear()
  }
}
/**
 * 数组去重函数
*/
export const unique = (arr) => {
  const tmp = new Map()
  return arr.filter(item => {
    if (typeof (item) !== 'string') {
      item = JSON.stringify(item)
    }
    return (!tmp.has(item) && tmp.set(item, 1))
  })
}

export const day = {
  now: (value) => {
    return (value && dayjs(value)) || dayjs()
  },
  nowF: (format = 'YYYY-MM-DD') => {
    return dayjs().format(format)
  },
  format: (value, format = 'YYYY-MM-DD') => {
    return dayjs(value).format(format)
  },
  isValid: (value, format = 'YYYY-MM-DD') => {
    return dayjs(value, format, true).isValid()
  },
  dayFormat: (value, format = 'YYYY-MM-DD') => {
    if (!value) return ''
    if (value.indexOf('-') !== -1) {
      value = value.replace(/\/Date\((-\d+)\)\//g, '$1')
    } else {
      value = value.replace(/\/Date\((\d+)\)\//g, '$1')
    }
    return dayjs(new Date(+value)).format(format)
  },
  fromNow: (value) => {
    if (!value) return ''
    if (value.indexOf('-') !== -1) {
      value = value.replace(/\/Date\((-\d+)\)\//g, '$1')
    } else {
      value = value.replace(/\/Date\((\d+)\)\//g, '$1')
    }
    return dayjs(new Date(+value)).locale('zh-cn').fromNow()
  },
  /**
   * 秒级时间戳转换
   */
  unixFormat: (value, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (!value) return ''
    return dayjs.unix(value).format(format)
  },
  minMax: (values, format = 'YYYY-MM-DD') => {
    if (!values || values.length === 0) return []
    const _values = values.map(item => {
      const value = item.replace(/\/Date\((\d+)\)\//g, '$1')
      return dayjs(new Date(+value))
    })
    const max = dayjs.max(_values).format(format)
    const min = dayjs.min(_values).format(format)
    return [min, max]
  },
  /**
   * 获取本周周一和周日日期
   */
  getCurrentWeek: () => {
    const start = dayjs().isoWeekday(1).format('YYYY-MM-DD') // 本周一
    const end = dayjs().isoWeekday(7).format('YYYY-MM-DD') // 本周日
    return [start, end]
  },
  /**
   * 获取前 i 周的周一和周日日期，并以数组的方式返回。
   * 当 i=1，获取的是上周一和上周日的日期；
   * 当 i=2，获取的是上上周一和上上周日的日期
   * ...以此类推
   * @param i
   */
  getLastWeek: (i = 1) => {
    let weekOfDay = parseInt(dayjs().day())// 计算今天是这周第几天
    let lastMonday = dayjs().add(-7 * i - weekOfDay + 1, 'day').format('YYYY-MM-DD')// 周一日期
    let lastSunday = dayjs().add(-7 * (i - 1) - weekOfDay, 'day').format('YYYY-MM-DD')// 周日日期
    return [lastMonday, lastSunday]
  },
  /**
   * 获取本月第一天和最后一天日期
   */
  getCurrentMonth: () => {
    const start = dayjs().date(1).format('YYYY-MM-DD') // 本月第一天
    const end = dayjs().date(1).add(1, 'M').add(-1, 'd').format('YYYY-MM-DD') // 本月最后一天
    return [start, end]
  },
  /**
   * 获取前 i 月第一天和最后一天日期
   */
  getLastMonth: (i = 1) => {
    const start = dayjs().date(1).add(-i, 'M').format('YYYY-MM-DD') // 本月第一天
    const end = dayjs().date(1).add(-i + 1, 'M').add(-1, 'd').format('YYYY-MM-DD') // 本月最后一天
    return [start, end]
  },
  /**
   * 获取前 i 月月份
   */
  obtainLastMonth: (i = 1) => {
    return dayjs().date(1).add(-i, 'M').format('YYYY-MM') // 前i月
  },
  /**
   * 获取昨天日期
  */
  getYesterday: () => {
    const start = dayjs().add(-1, 'd').format('YYYY-MM-DD') // 距离当前 day 天的日期
    return [start, start]
  },
  /**
   * 获取 距离当前 day 天的日期和今天日期
   */
  getBeforeDay: (day = 10) => {
    const start = dayjs().add(-day, 'd').format('YYYY-MM-DD') // 距离当前 day 天的日期
    const end = dayjs().format('YYYY-MM-DD') // 当前日期
    return [start, end]
  },
  /**
   * 获取 距离当前 week 周的日期和今天日期
   */
  getBeforeWeek: (week = 8) => {
    const start = dayjs().add(-((week - 1) * 7), 'd').format('YYYY-MM-DD') // 距离当前 day 天的日期
    const end = dayjs().format('YYYY-MM-DD') // 当前日期
    return [start, end]
  },
  /**
   * 获取 距离当前 week 周的日期和今天日期
   */
  getBeforeMonth: (month = 12) => {
    const start = dayjs().add(-month + 1, 'M').add(1, 'd').format('YYYY-MM-DD') // 距离当前 month 月的日期
    const end = dayjs().format('YYYY-MM-DD') // 当前日期
    return [start, end]
  },
  /**
   * 获取季度开始结束时间
   */
  getQuarterDate: (quarter = 0, year = '', month = '') => {
    const format = `${year || 'YYYY'}-MM-DD`
    let start = year && dayjs().startOf('year').format(format)
    let end = year && dayjs().endOf('year').format(format)
    if (quarter) {
      start = dayjs().quarter(quarter).startOf('quarter').format(format)
      end = dayjs().quarter(quarter).endOf('quarter').format(format)
    }
    if (month !== '') {
      start = dayjs().month(month - 1).startOf('month').format(format)
      end = dayjs().month(month - 1).endOf('month').format(format)
    }
    return [start, end]
  },
  /**
   * 获取某月的开始结束时间
   */
  getMonthStartEndTime: (month = 0, format = 'YYYY-MM-DD') => {
    const start = dayjs().month(month - 1).startOf('month').format(format)
    const end = dayjs().month(month - 1).endOf('month').format(format)
    return [start, end]
  }
}

export const tool = {
  trim: (value) => {
    return value.replace(regex.trim, '')
  },
  removeHtmlTag: (value) => {
    return value.replace(regex.htmlspace, '')
  },
  /**
 * 图片转换为base64
 * @param {图片文件} file
 * @param {回调函数}} cb
 */
  getFileBase64: (file, cb) => {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = cb
  },
  removeImageBase64Prefix: (info) => {
    return ((info.target && info.target.result) || info).replace(/data:image\/([jpg|png|jpeg||gif])+;base64,/, '')
  },
  downLoadFile: (data, title = '文件下载', type = 'excel') => {
    if (!data) {
      return
    }
    let ext = 'xls'
    let blob = new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' })
    if (type === 'pdf') {
      blob = new Blob([data], { type: 'application/pdf;charset=utf-8' })
      ext = 'pdf'
    } else if (type === 'zip') {
      blob = new Blob([data], { type: 'application/zip' })
      ext = 'zip'
    }
    let downloadElement = document.createElement('a')
    let href = window.URL.createObjectURL(blob) // 创建下载的链接
    downloadElement.href = href
    let extArr = title.split('.')
    // let _ext = extArr[extArr.length - 1]
    downloadElement.download = extArr.length > 1 ? `${title}` : `${title}.${ext}` // 下载后文件名s
    document.body.appendChild(downloadElement)
    downloadElement.click() // 点击下载
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
  },
  downLoadUrlFile: (url, filename = '文件下载') => {
    const _url = url.replace(/http(s)*:\/\/f4.youbaolian.cn/, '/pdf')
    return axios({ url: _url, responseType: 'blob' }).then(res => {
      if ('download' in document.createElement('a')) {
        const reader = new FileReader()
        reader.readAsDataURL(res.data)
        reader.onload = e => {
          const a = document.createElement('a')
          a.download = filename
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      } else {
        navigator.msSaveBlob(res.data, decodeURI(filename))
      }
    })
  },
  unitConvert: (value) => {
    if (!value && isNaN(value)) {
      return ''
    }
    const moneyUnits = ['元', '万', '亿', '万亿']
    let dividend = 10000
    let currentNum = value
    // 转换数字
    let currentUnit = moneyUnits[0]
    // 转换单位
    for (let i = 0; i < 4; i++) {
      currentUnit = moneyUnits[i]
      if (`${currentNum}`.split('.')[0].length < 5) {
        break
      }
      currentNum = currentNum / dividend
    }
    var m = { num: 0, unit: '' }
    m.num = (currentNum || 0).toFixed(2)
    m.unit = currentUnit
    return m
  },
  currency (value, num = 2) {
    value = (+value || 0).toFixed(num)
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  debounce (fn, interval = 200, ctx) {
    var timer
    return function (...params) {
      return function (...params) {
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(function () {
          timer = null
          fn.apply(ctx, params)
        }, interval)
      }
    }
  },
  sleep (duration = 100) {
    return new Promise(resolve => setTimeout(resolve, duration))
  },
  UUID (uppercase = true) {
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0 // 生成0-15的随机数
      const v = c === 'x' ? r : (r & 0x3 | 0x8) // x用随机数，y用规范的变体位
      return v.toString(16) // 转换为十六进制字符
    })
    return uppercase ? uuid.toUpperCase() : uuid
  }
}

export const c = cookie
const isMicroApp = process.env.IS_MICRO_APP // true // true 开启子集项目集成
// saas端打开新窗口
export const openNavUrl = (_url, title, host = window.location.host, target = 'self', isCross = true, type = 0, id = '') => {
  let regex = /^\/|(http(s)?:\/\/)|\/$/g
  if (isCross) {
    regex = /^\/|(http(s)?:\/\/)|(-new)|\/$/g
  }
  let protocol = window.location.protocol

  let _host = host.replace(regex, '')
  if (isCross && isMicroApp) { // 针对集成模式，跳转java/net的地址处理
    /* const continueToCXV3 = ['Home/LoginOut']
    const newUrl = _url.replace(regex, '').replace(/^\//, '')
    if (!continueToCXV3.includes(newUrl)) {
      _host = host.replace(/^\/|(http(s)?:\/\/)|\/$/g, '')
      _url = _url.includes('j/') ? _url : `j/${newUrl}`
    } */
    protocol = protocol.replace('https', 'http')
  }
  if (isCross && ['/Policy/Add', '/Policy/Lot', '/Policy/Lotlicense'].includes(_url)) {
    protocol = protocol.replace('https', 'http')
  }
  let url = `${protocol}//${_host}/${_url.replace(regex, '')}`
  if (host.indexOf('sxcore.youbaolian.cn') !== -1) { // 特殊处理寿险跳转
    url = `http://${host.replace(regex, '')}/${_url.replace(regex, '')}`
  }
  if (/^(https?:|mailto:|tel:)/.test(_url)) {
    url = _url
  }
  let config = {
    customerId: 0,
    type: type || 0,
    id: id || Math.random().toString(),
    url: url,
    title: title
  }
  console.log(JSON.stringify(config))
  /* if (_url === '/Home/LoginOut') { // 针对退出特殊处理
    location.href = url
  } else { */
  if (window.IAgencyWebCall && target === 'blank') {
    window.IAgencyWebCall('OpenUrl', JSON.stringify(config), '')
  } else {
    if (target === 'blank') {
      window.open(url)
    } else {
      location.href = url
    }
  }
  // }
}
export const openQmm = (partnerId, customerId) => {
  var url = location.origin.replace('-new', '') + '/yblQmm.html'
  if (partnerId) {
    var userInfoJson = {
      customerId: customerId,
      partnerId: partnerId
    }
    url = url + '?userinfojson=' + JSON.stringify(userInfoJson)
  }
  if (window.IAgencyWebCall && +(window.klb_req.ver.replace(/\./g, '')) < 730) window.IAgencyWebCall('OpenUrl', JSON.stringify({ id: 2852176355, type: 50, url: url }), '')
  else window.open(url)
}
export const getMac = () => {
  if (window.klb_req) {
    return window.klb_req.clientId
  }
  return ''
}

export const getVersion = () => {
  if (window.klb_req) {
    return window.klb_req.ver
  }
  return ''
}

export const openNewWindow = (title, version = 730) => {
  if (version >= 730) {
    const requestBody = {
      type: 200,
      id: new Date().getTime().toString(),
      url: `${window.location.origin}/login`,
      title: title
    }
    if (window.IAgencyWebCall) {
      window.IAgencyWebCall('OpenUrl', JSON.stringify(requestBody), '')
    }
  }
}

export const idCardBringMessage = (idCard) => {
  let UUserCard = idCard
  // 获取出生日期
  UUserCard = UUserCard.substring(6, 10) + '-' + UUserCard.substring(10, 12) + '-' + UUserCard.substring(12, 14)
  // 获取性别
  let sex
  console.log(+idCard.substr(16, 1) % 2)
  console.log((+idCard.substr(16, 1) % 2) === 0)
  if (+idCard.substr(16, 1) % 2 === 0) {
    sex = 2
  } else {
    sex = 1
  }
  // 获取年龄
  // var myDate = new Date()
  // var month = myDate.getMonth() + 1
  // var day = myDate.getDate()
  // var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1
  // if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) === month && UUserCard.substring(12, 14) <= day) {
  //   age++
  // }
  let arr = { sex: sex, birthday: UUserCard }
  return arr
}

export const RMB2Chinese = (value) => {
  if (!value || isNaN(value)) {
    return ''
  }
  let strOutput = ''
  let strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分'
  let num = parseFloat(value) + '00'
  let intPos = num.indexOf('.')
  if (intPos >= 0) {
    num = num.substring(0, intPos) + num.substr(intPos + 1, 2)
  }
  strUnit = strUnit.substr(strUnit.length - num.length)
  for (var i = 0; i < num.length; i++) {
    strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1)
  }

  // console.log(num, value, strOutput)
  return (+value < 0 ? '负' : '') + strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, '零元')
}

export const getVuex = (name) => {
  const vuexString = storage.getItem('vuex')
  let vuex = (vuexString && JSON.parse(vuexString)) || {}
  return vuex[name]
}
export const initPieChart = (chart, data) => {
  let total = data.reduce((prev, curr) => { return prev + curr.value }, 0)
  chart.coordinate('theta', {
    radius: 0.75
  })
  chart.data(data)
  chart.tooltip({
    showTitle: false,
    showMarkers: false
  })
  chart
    .interval()
    .adjust('stack')
    .position('value')
    .color('type', ['#d24b4b', '#0d05c1', '#30c6d2', '#f7c387', '#16e2cb', '#2fbdad', '#dedbbe'])
    .label('type', (val) => {
      return {
        style: {
          opacity: 1,
          fontSize: 12,
          // shadowBlur: 2,
          shadowColor: 'rgba(102, 102, 102, .45)'
        },
        content: (obj) => {
          return obj.type + '：' + obj.value
        }
      }
    })
    .tooltip('type*value', (type, value, percent) => {
      value = `${value}(${(value / total * 100).toFixed(2)}%)`
      return {
        name: type,
        value: value
      }
    })

  chart.interaction('element-active')
  chart.render()
}

export const compareValues = (originValue, mathValue) => {
  if (!originValue || !mathValue) {
    return false
  }
  let _originValue = originValue
  let _matchValue = mathValue
  if (!Array.isArray(originValue)) {
    _originValue = originValue.split(',')
  }
  if (!Array.isArray(mathValue)) {
    _matchValue = mathValue.split(',')
  }
  return _matchValue.some(item => _originValue.includes(item))
}

const getUserInfo = () => {
  const customer = getVuex('customer')
  return customer && customer['CUSTOMER_LOGINCUSTOMER']
}

export const isDataAuthority = () => {
  const loginUser = getUserInfo() // getVuex('customer')['CUSTOMER_LOGINCUSTOMER']
  const pratner = loginUser && loginUser.data && loginUser.data.Pratner
  return (pratner && pratner.isdataauthority === 1) || false // 监管模式 0：显示 1：不显示
}

// 标签管理入口控制（WZPE-46980）：仅创收版 V6 及以上、专业版(5)/旗舰版(6)商户可用
// 版本上下文取登录态 Pratner.partnerEx，store 未就绪时回退登录写入的 partnerEx cookie；revenueVersion 空视为 V5
export const SALES_LABEL_DENY_TIP = '标签管理仅对创收版 V6 及以上的专业版/旗舰版商户开放，如需使用请联系您的客户经理升级！'
export const canUseSalesLabel = () => {
  const loginUser = getUserInfo()
  let partnerEx = loginUser && loginUser.data && loginUser.data.Pratner && loginUser.data.Pratner.partnerEx
  if (!partnerEx) {
    try {
      partnerEx = JSON.parse(cookie.getCookie('partnerEx') || '{}')
    } catch (e) {
      partnerEx = {}
    }
  }
  const revenueMajor = parseFloat(String(partnerEx.revenueVersion || '').replace(/[^\d.]/g, '')) || 5
  return revenueMajor >= 6 && [5, 6].includes(+partnerEx.v5Flag)
}

/**
 * 车险专业版、标准版、企业版的机构负责人、团队长、出单内勤三类角色
 * @returns true false
 */
export const isSpecialChannel = () => {
  // const customer = getVuex('customer')
  const loginUser = getUserInfo() // customer && customer['CUSTOMER_LOGINCUSTOMER']
  /* const Pratner = loginUser && loginUser.data && loginUser.data.Pratner
  const RoleGroupIds = loginUser && loginUser.data && loginUser.data.RoleGroupIds
  return Pratner && [3, 4, 22].includes(+Pratner.systemVersion) && [12, 13, 14].includes(+RoleGroupIds) */
  // return false
  return loginUser.IsChannelCustomer
}

export const checkAuthority = (values) => {
  const loginUser = getUserInfo()
  const roleAuthorization = ((loginUser && loginUser.data && loginUser.data.RoleAuthorization) || '').split(',')
  return compareValues(roleAuthorization, values) || roleAuthorization.includes('1')
}

export const getConfigInfo = () => {
  const partner = localStorage.getItem('latestPartner')
  const latestPartner = (partner && JSON.parse(partner)) || ['']
  const { pathname } = location
  return customDomainAndLogo.find(item => item.subdomain === latestPartner[0].subdomain || item.path === pathname)
}

// base64解码
export const decodeBase64Content = (base64Content) => {
  let commonContent = base64Content.replace(/\s/g, '+')
  commonContent = Buffer.from(commonContent, 'base64').toString()
  return commonContent
}

// base64编码
export const encodeBase64Content = (commonContent) => {
  let base64Content = Buffer.from(commonContent).toString('base64')
  return base64Content
}

// 将文件大小格式化为常见显示
export const formatFileSize = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const units = ['Bytes', 'K', 'M', 'G'] // 按需扩展单位[1,4](@ref)

  // 计算单位索引（限制最大单位为MB）
  const unitIndex = Math.min(
    Math.floor(Math.log(bytes) / Math.log(k)),
    units.indexOf('M') // 强制最大显示MB[2,3](@ref)
  )

  // 计算格式化数值
  const size = parseFloat((bytes / Math.pow(k, unitIndex)).toFixed(decimals))

  return `${size} ${units[unitIndex]}`
}



// WEBPACK FOOTER //
// ./src/utils/index.js